<template>
  <v-container fluid>
    <v-layout row>
      <v-flex xs12 md10 offset-md1 lg8 offset-lg2>
        <v-breadcrumbs divider="/">
          <v-breadcrumbs-item :to="{ name: 'my-services' }" exact>Mine tjenester</v-breadcrumbs-item>
          <v-breadcrumbs-item disabled>Mekke Publisering</v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-progress-linear v-if="isSubmitting" :indeterminate="true"></v-progress-linear>
        <notifications group="mekke-list" key="mekke-list" />

        <v-data-table
          :headers="headers"
          :items="mekke"
          hide-actions
          class="elevation-1"
          item-key="servername"
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">
              <router-link class="big-link" :to="{ 'name': 'mekke-detail', params: { servername: props.item.servername } }">
                {{ props.item.servername }}
              </router-link>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import MekkeService from '@/services/MekkeService'

export default {
  name: 'mekke-list',
  mounted () {
    this.init()
  },
  data () {
    return {
      isSubmitting: false,
      headers: [
        { text: 'Domene', sortable: false, class: 'has-big-links' }
      ],
      mekke: []
    }
  },
  methods: {
    async init () {
      const response = await this.runService(this, 'mekke-list', MekkeService.getList)
      if (response) {
        this.mekke = response.data
      }
    }
  }
}
</script>

<style scoped>
.card {
  max-width: 340px !important;
  font-size: 1.2em;
}

.card .v-btn {
  font-size: 1em;
}
</style>
